import { render } from "./DeployedResourceTab.vue?vue&type=template&id=4f265a0e&scoped=true"
import script from "./DeployedResourceTab.vue?vue&type=script&lang=js"
export * from "./DeployedResourceTab.vue?vue&type=script&lang=js"

import "./DeployedResourceTab.vue?vue&type=style&index=0&id=4f265a0e&lang=scss&scoped=true"
import "./DeployedResourceTab.vue?vue&type=style&index=1&id=4f265a0e&scoped=true&lang=css"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f265a0e"]])

export default __exports__